import { updatePhoneNumber } from '../helpers/update-phone-number';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface UpdatePhoneNumberFnPayload {
    phoneNumber: string;
}

export type UpdatePhoneNumberFn = (
    payload: UpdatePhoneNumberFnPayload,
) => Promise<void>;

export function initUpdatePhoneNumberFn({
    dependencies,
}: DomainInitPayload): UpdatePhoneNumberFn {
    return async (payload) => {
        await updatePhoneNumber(payload, dependencies);
    };
}
